export default __webpack_public_path__ + "static/media/news93.38502d93.jpg";